import { MDBBadge } from "mdb-react-ui-kit";
import { useContext } from "react";
import { TranslationContext } from "../../context/translations/translations-context";
import { useCurrentUserRoles } from "../../hooks/useCurrentUserRoles";
import useResumeDocumentSection from "../../hooks/useResumeDocumentSection";

export default function TopRightSection() {
    const { translations, displayLanguage } = useContext( TranslationContext );
    const { user } = useResumeDocumentSection();
    const { isClientRole } = useCurrentUserRoles();

    return (
        <div className="text-center">
            <h2 className="text-white">{ translations.topRightSection.title }</h2>
            <div className={ isClientRole ? 'hide-for-client' : '' }>
                <MDBBadge pill className="mx-2" color="info" light>
                    { `ACO__${ user?.firstName }_${ user?.lastName?.toUpperCase() || "" }_CV_${ displayLanguage.toUpperCase() }.pdf` }
                </MDBBadge>
            </div>
        </div>
    );
}
